export default {
  SET_DREAMS (state, dreams) {
    state.dreams = dreams
  },
  ADD_DREAM (state, dream) {
    state.dreams.push(dream)
  },
  UPDATE_DREAM (state, dream) {
    const dreamIndex = state.dreams.findIndex((t) => t.id === dream.id)
    Object.assign(state.dreams[dreamIndex], dream)
  },
  DELETE_DREAM (state, dream) {
    const dreamIndex = state.dreams.findIndex((t) => t.id === dream.id)
    state.dreams.splice(dreamIndex, 1)
  }
}
